<template>
  <div class="selector" :class="{ is_selected: cartQuantity }">
    <button
      type="button"
      v-for="n in availableQuantity"
      :key="n"
      @click="updateCart(n)"
      :class="{ is_active: n == cartQuantity }"
    >
      <span>{{ n }}</span>
    </button>
    <the-dropdown
      v-if="dropDownOptions.length"
      @value-change="updateCart"
      :raw="true"
      :isDark="3 * quantityStep < cartQuantity"
      :defaultValue="dropDownDefaultValue"
      :options="dropDownOptions"
    ></the-dropdown>
  </div>
</template>

<script>
import TheDropdown from '../TheDropdown.vue'
export default {
  components: { TheDropdown },
  props: {
    product: Object,
    maxValue: {
      type: Number,
      default: 10,
    },
    maxAvailable: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    quantityStep() {
      return this.product?.properties?.quantity_step || 1
    },
    dropDownOptions() {
      if (this.maxAvailable <= this.quantityStep * 4) {
        return []
      }
      const settings = [{ label: 'More', value: null }]
      for (let n = 4; n <= this.maxValue; n++) {
        const value = n * this.quantityStep
        if (value > this.product.quantity_available) {
          break
        }
        const item = {
          label: `${value}`,
          value,
        }

        settings.push(item)
      }
      return settings
    },
    cartQuantity() {
      const record = this.$store.state.cart.items.find((v) => v.id === this.product.id)
      if (record) {
        return record.quantity
      } else {
        return 0
      }
    },
    dropDownDefaultValue() {
      return this.cartQuantity > this.quantityStep * 3 ? this.cartQuantity : null
    },
    availableQuantity() {
      const steps = [1, 2, 3]
      const quantityArray = steps.map((v) => v * this.quantityStep)
      return quantityArray.filter((v) => v <= this.maxAvailable)
    },
  },
  methods: {
    getCartQuantity(id) {
      const record = this.$store.state.cart.items.find((v) => v.id === id)
      if (record) {
        return record.quantity
      } else {
        return 0
      }
    },
    updateCart(quantity) {
      if (quantity === this.cartQuantity || (quantity === null && this.cartQuantity > this.quantityStep * 4)) {
        this.$store.dispatch('cart/updateCart', { product: this.product, quantity: 0 })
      } else {
        if (quantity !== null) this.$store.dispatch('cart/updateCart', { product: this.product, quantity })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.selector {
  border: 1px solid #000;
  border-radius: 28px;
  padding: 8px;
  display: inline-block;
  margin-bottom: 10px;
  transition: background-color 0.2s, border-color 0.2s;

  &.is_selected {
    background: $colorWhite;
    border-color: $colorWhite;
  }

  button {
    @include fontStyleNavi;
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    border: 0;
    background: transparent;
    border-radius: 20px;
    cursor: pointer;
    border-radius: 50%;
    position: relative;
    transition: none;
    transition: color 0.3s, background-color 0.3s;

    span {
      position: relative;
      z-index: 3;
    }

    &:hover {
      background: $colorBeige;
    }

    &.is_active {
      background: $colorBlack;
      color: #fff;
    }
  }
}
</style>
